import React from 'react';
import {
  addPathToList,
  Configure_screen_amount,
  Enable_additional_instructions,
  enter_amount_title,
  getSubCategoryId,
  Payment_amount,
  show_Balance,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import { arrangeScreenInJson } from '../screens/ScreensOrdering';

//= ========================================================================
const Panel_F08_RequestPaymentEnterAmount = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'how_much_to_transfer',
  ];
  const apiTextList = [
    'please_enter_valid_amount',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const subCategoryIdDefault = getSubCategoryId({ sub_category: myScreen.sub_category, duplication_number: 0 });
  const { amount } = globJSON.configurations.services[subCategoryId];
  const onValueChanged = (key, value) => {
    amount[key] = value;
    arrangeScreenInJson(globJSON, onConfigChanged);
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={Payment_amount}
      panelSubHeadline={enter_amount_title}
      editTextList={addPathToList(editTextList, `configurations/services/${subCategoryId}/amount/`)}
      apiTextList={addPathToList(apiTextList, `configurations/services/${subCategoryId}/amount/`)}
      editTextListDefault={addPathToList(editTextList, `configurations/services/${subCategoryIdDefault}/amount/`)}
      tooltipsTitles={globJSON.configurations.services[subCategoryId].screens_ordering}
      paragraph={Configure_screen_amount}
      language={language}
    >
      <SwitcherPanel
        text={show_Balance}
        value={amount.show_account_balance}
        onValueChanged={(value) => {
          onValueChanged('show_account_balance', value);
        }}
        marginTop={12}
      />
      <SwitcherPanel
        text={Enable_additional_instructions}
        value={amount.enable_additional_instruction}
        onValueChanged={(value) => {
          onValueChanged('enable_additional_instruction', value);
        }}
        marginTop={12}
        marginBottom={30}
      />
    </FullPagePanel>
  );
};

export default Panel_F08_RequestPaymentEnterAmount;
